
import { Route } from '@/app/router'

const Distributions = () => import('./index.vue')

const DistributionsMeta = {
	sort: 12,
	displayInSidebar: true,
	displayName: 'distribution',
	icon: 'fal share-square',
	activeIcon: 'fas share-square'
}

const DistributionsProps = ['page', 'perPage']

export default new Route('/distributions', Distributions)
	.as('Dashboard:Distributions')
	.meta(DistributionsMeta)
	.props(DistributionsProps)
	.permissions(['VIEW_OEM_DISTRIBUTION', 'OEM_ENABLED'])
